export function getAreRolesEnabled(stack: StackDto | null): boolean {
    return !!stack?.options?.roles__enabled
}
